import React, { CSSProperties, FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Container, LinkButton, Text } from './ListButtons.style';

export interface LinkType {
  text: string;
  url: string;
  icon?: any;
  active?: boolean;
  shallow?: boolean;
  hideOnMobile?: boolean;
}

interface Props {
  containerStyle?: CSSProperties;
  links: LinkType[];
  onClick: (link: LinkType) => void;
}

const ListButtons: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <Container style={props.containerStyle}>
      {props.links.map((link) => (
        <LinkButton
          $active={link.active}
          $hideOnMobile={link.hideOnMobile}
          key={link.text}
          data-testid={`link-button-${link.text.replace(' ', '-')}`}
          onClick={() => props.onClick(link)}
          type="button"
        >
          {link.icon && <FontAwesomeIcon icon={link.icon} color={theme.textDark} />}

          <Text>{link.text}</Text>
        </LinkButton>
      ))}
    </Container>
  );
};

export default ListButtons;
